export const icons = [
  'arrow-left',
  'arrow-right',
  'calendar',
  'checkmark',
  'checkmark-filled',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'close',
  'apple',
  'google',
  'download',
  'mail',
  'eye',
  'eye-slash',
  'facebook',
  'filter',
  'heart',
  'heart-filled',
  'instagram',
  'link',
  'linkedin',
  'trend-down',
  'trend-up',
  'location-filled',
  'menu',
  'pinterest',
  'play-filled',
  'plus',
  'search',
  'tiktok',
  'trash',
  'tumblr',
  'volumn',
  'volumn-slash',
  'X',
  'youtube',
] as const

export type IconName = (typeof icons)[number]

export const iconSizes = ['sm', 'md', 'lg'] as const
export type IconSize = (typeof iconSizes)[number]

export type IconArgs = {
  name: IconName
  size?: IconSize
}
